import { ToastType, ToastWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { imgPath } from '../../../../../../commonInfra/utils/ImgUrl';
import { isCnameVerified } from '../helpers/CustomDomainHelper';
import CustomDomainHttpClient from '../serverAPI/CustomDomainHttpClient';
import { UpdateCustomDomainRequest } from '../serverAPI/requests/AddOrUpdateCustomDomainRequest';
import { AddOrUpdateCustomDomainSettingRequest, CustomDomainSettingResponse } from '../serverAPI/types/CustomDomainTypes';
import { customDomainButtonStyle, customDomainContentStyle, customDomainHeaderContainer, customDomainSubHeaderStyle, successIconStyle, unavailableIconStyle } from '../styles/CustomDomainStyles';
import { FileUpload } from './FileUpload';

export interface UploadSSLCertificateState {
  isUploading: boolean;
  checkBox: boolean;
}

export interface UploadSSLCertificateProps {
  customDomainSetting: CustomDomainSettingResponse;
  triggerFetchCustomDomain(): void;
}

export class UploadSSLCertificateView extends React.PureComponent<UploadSSLCertificateProps, UploadSSLCertificateState> {
    public constructor(props: UploadSSLCertificateProps) {
      super(props);
      this.state = {
        isUploading: false,
        checkBox: false
      };
    }

    private handleChange = (selectedFile: File) => {
      //Fetch TLS cert and privateKey from this and send it using an API call.
      const customDomainSetting: AddOrUpdateCustomDomainSettingRequest = {
        site_luid: this.props.customDomainSetting.site_luid,
        custom_domain: this.props.customDomainSetting.custom_domain,
        status: this.props.customDomainSetting.status,
        tls_certificate: '',
        tls_certificate_private_key: ''
      };

      this.setState({isUploading: true});
      CustomDomainHttpClient.requestPutOrPost(new UpdateCustomDomainRequest(customDomainSetting)).then((res: CustomDomainSettingResponse)  => {
         ToastWidget.show({
          message: 'Uploading SSL certficate succeeded',
          testId: 'toast-upload-cert-success',
          toastType: ToastType.Success,
        });
         this.props.triggerFetchCustomDomain();
       }).catch(err => {
         ToastWidget.show({
          message: 'Uploading SSL certficate failed',
          testId: 'toast-upload-cert-failed',
          toastType: ToastType.Error,
        });
       }).finally(() => {
        this.setState({isUploading: false});
       });
    };

    private renderIcon() {
      if(this.props.customDomainSetting?.tls_certificate_uploaded_date) {
        return <img src={imgPath('notification_success.svg')} alt='' className={successIconStyle}/>;
      }
      if(isCnameVerified(this.props.customDomainSetting?.status)) {
        return <img src={imgPath('proceed.svg')} alt='' className={successIconStyle}/>;
      }

      return <img src={imgPath('not_available.svg')} alt='' className={unavailableIconStyle}/>;
    }

    public render() {
      return (
      <>
      <div className={customDomainHeaderContainer}>
        {this.renderIcon()}
        <strong className={customDomainSubHeaderStyle}>{Messages.CustomDomainSetting_uploadSslLabel()}</strong>
      </div>
      { isCnameVerified(this.props.customDomainSetting?.status)? <div className={customDomainContentStyle}>
          <span style={{margin:0}}>{Messages.CustomDomainSetting_uploadSslDescription()}</span>
          <div className={customDomainButtonStyle}>
              <FileUpload promptText={Messages.CustomDomainSetting_uploadSslButton()} tbTestId='button-cert-file-upload' onFileSelect={this.handleChange}/>
          </div>
        </div> : null
      }
      </>
      );
    }
}